import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { getPasswordChecks } from "../../utils/passwordRules";

const PasswordRules = ({
  password = "",
  username = "",
  role,
  confirm = "",
  showPolicy = false,
  dark = false,
}) => {
  const checks = getPasswordChecks(password, username, role);
  if (confirm !== undefined && confirm !== null) {
    checks.push({
      id: "match",
      label: "Passwords match",
      ok: Boolean(password) && password === confirm,
    });
  }
  const passed = checks.filter((check) => check.ok).length;
  const strength = checks.length ? passed / checks.length : 0;
  const tone =
    strength >= 1 ? "success.main" : strength >= 0.5 ? "warning.main" : "error.main";

  return (
    <Box
      sx={{
        mb: 2.5,
        p: 1.75,
        border: "1px solid",
        borderColor: dark ? "rgba(255,255,255,0.14)" : "divider",
        borderRadius: 1,
        bgcolor: dark ? "rgba(255,255,255,0.06)" : "grey.50",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          color: dark ? "rgba(248,250,252,0.7)" : "text.secondary",
        }}
      >
        Password strength
      </Typography>
      <LinearProgress
        variant="determinate"
        value={Math.round(strength * 100)}
        sx={{
          mt: 0.75,
          mb: 1.5,
          height: 6,
          borderRadius: 99,
          bgcolor: dark ? "rgba(255,255,255,0.12)" : "grey.200",
          "& .MuiLinearProgress-bar": { bgcolor: tone },
        }}
      />
      <Stack spacing={0.5}>
        {checks.map((check) => (
          <Box
            key={check.id}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              color: check.ok
                ? "success.light"
                : dark
                  ? "rgba(248,250,252,0.62)"
                  : "text.secondary",
            }}
          >
            {check.ok ? (
              <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
            ) : (
              <RadioButtonUncheckedIcon sx={{ fontSize: 16 }} />
            )}
            <Typography variant="caption" sx={{ fontWeight: check.ok ? 600 : 400 }}>
              {check.label}
            </Typography>
          </Box>
        ))}
      </Stack>
      {showPolicy ? (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mt: 1.25,
            color: dark ? "rgba(248,250,252,0.55)" : "text.secondary",
          }}
        >
          Passwords must be updated every 90 days.
        </Typography>
      ) : null}
    </Box>
  );
};

export default PasswordRules;
